import { component } from 'picoapp'
import { removeAddon, updateAddon } from '@/lib/cart.js'

export default component((node, ctx) => {
  const button = node.querySelector('.js-remove-item')
  const decrease = node.querySelector('.js-remove-single')
  const increase = node.querySelector('.js-add-single')
  const itemQty = node.querySelector('.js-change-quantity')
  const id = node.getAttribute('data-id')

  button.addEventListener('click', e => {
    e.preventDefault();
    removeAddon(id)
  })
  
  itemQty.addEventListener('change', function() {
    const qty = parseInt(this.value);
    console.log('qty');
    updateAddon(id, qty)
  });
})
